"use client";

import React from "react";
import { createIcon } from "@chakra-ui/react";

const RegulationsAndGuidelinesIcon = createIcon({
  displayName: "RegulationsAndGuidelinesIcon",
  viewBox: "0 0 37 45",
  path: (
    <>
      <path
        d="M8.09,45c-2.24,0-4.14-.77-5.72-2.31-1.58-1.54-2.37-3.39-2.37-5.57V7.88C0,5.7.79,3.84,2.37,2.31,3.95.77,5.86,0,8.09,0h28.91v33.75c-.96,0-1.78.33-2.46.98-.67.66-1.01,1.45-1.01,2.39s.34,1.73,1.01,2.39c.67.66,1.49.98,2.46.98v4.5H8.09ZM4.62,29.98c.54-.26,1.1-.45,1.68-.56.58-.11,1.18-.17,1.79-.17h1.16V4.5h-1.16c-.96,0-1.78.33-2.46.98-.67.66-1.01,1.45-1.01,2.39v22.11ZM13.88,29.25h18.5V4.5H13.88v24.75ZM8.09,40.5h21.56c-.23-.53-.41-1.06-.55-1.6-.13-.54-.2-1.13-.2-1.77,0-.6.06-1.18.17-1.74.12-.56.31-1.11.58-1.63H8.09c-1,0-1.83.33-2.49.98-.66.66-.98,1.45-.98,2.39s.33,1.78.98,2.42c.66.64,1.48.96,2.49.96Z"
        fill="currentColor"
      />
    </>
  ),
  defaultProps: {
    boxSize: "1em",
  },
});

export default RegulationsAndGuidelinesIcon;
